exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.sem-permissao[data-v-cc0ee130] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  min-height: calc(100vh - 96px);\n}\n.sem-permissao__conteudo[data-v-cc0ee130] {\n  min-height: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false,"url":true,"alias":{"fonts":"..fonts"}}!./~/vue-loader/lib/style-compiler?{"id":"data-v-cc0ee130","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sem-permissao/SemPermissao.vue
// module id = 998
// module chunks = 1